export default "__VITE_PUBLIC_ASSET__4aa0f011__"